export default __webpack_public_path__ + "static/media/all_tasks_icon.83e77df5.svg";